<template>
  <van-tabs v-model:active="active">
    <van-tab title="检查分析订单">
      <van-card v-for="(userOrderMapVo, id) in userOrderList.userOrderMapVo" :key="id"
        :title="changeTitle(userOrderMapVo.orderId)" :thumb="require('./assets/img/once.png')"
        :price="userOrderMapVo.fee">
        <template #desc>
          <div>
            <p class="text3DIndentation"> 产品名称：{{ userOrderMapVo.productName }}</p>
            <p class="text3DIndentation"> 创建时间：{{ userOrderMapVo.updateTime }}</p>
          </div>
        </template>
        <template #footer>
          <van-button v-if="checkState(userOrderMapVo.state)" size="normal" type="success">{{ userOrderMapVo.state
          }}</van-button>
          <van-button v-else size="normal" disabled>{{ userOrderMapVo.state }}</van-button>
        </template>
      </van-card>
    </van-tab>
    <van-tab title="健康管理订单">
      <van-card v-for="(userOrderMapVo, id) in userHeartPlan.userOrderMapVo" :key="id"
        :title="changeTitle(userOrderMapVo.orderId)" :thumb="require('./assets/img/year.jpg')"
        :price="userOrderMapVo.fee">
        <template #desc>
          <div>
            <p class="text3DIndentation"> 产品名称：{{ userOrderMapVo.productName }}</p>
            <p class="text3DIndentation"> 创建时间：{{ userOrderMapVo.updateTime }}</p>
          </div>
        </template>
        <template #footer>
          <van-button v-if="checkState(userOrderMapVo.state)" size="normal" type="success">{{ userOrderMapVo.state
          }}</van-button>
          <van-button v-else size="normal" disabled>{{ userOrderMapVo.state }}</van-button>
        </template>
      </van-card>
    </van-tab>
    <van-tab title="卡劵订单">
      <van-card v-for="(userGiftCardsVo, id) in userGiftCards.userGiftCardsVo" :key="id"
        :title="changeTitle(userGiftCardsVo.giftId)" :thumb="require('./assets/img/gift.png')">
        <template #desc>
          <div>
            <p class="text3DIndentation"> 产品名称：{{ userGiftCardsVo.productName }}</p>
            <p class="text3DIndentation"> 卡劵说明：{{ userGiftCardsVo.discount }}</p>
            <p class="text3DIndentation"> 创建时间：{{ userGiftCardsVo.updateTime }}</p>
          </div>
        </template>
        <template #footer>
          <van-button v-if="checkStateStr(userGiftCardsVo.stateStr)" size="normal" type="success"
            @click="getUserGift(userGiftCardsVo.giftId)">{{
              userGiftCardsVo.stateStr }}</van-button>
        <van-button v-else size="normal" disabled>{{ userGiftCardsVo.stateStr }}</van-button>
        
        </template>
      </van-card>
      <van-button color="linear-gradient(to right, #f67f34, #d55809)" block @click="getHospGiftCards">向机构发起获取卡券请求</van-button>
    </van-tab>
  </van-tabs>
  <!--van-button color="linear-gradient(to right, #f67f34, #d55809)" block to="/productList">新增产品签约</van-button-->
</template>
<script>
import { ref, reactive, onMounted } from 'vue';
import { showConfirmDialog } from 'vant';
import request from '../../utils/request';
import { showToast } from 'vant';
import { getUserOrderList, getUserOrderHealthPlan, getdUserGiftCards } from '../../api/personOrder'
import { getAddHospGiftCards} from '../../api/bloodData'
import { useRouter } from 'vue-router';
import { postUserLog } from "../../api/userlog";
import { showDialog } from 'vant';
export default {
  setup() {
    const router = useRouter();
        const ulog = reactive({
            UserLog: {
                 path: "",
            },
        });
    const active = ref(2);
    const userOrderList = reactive({
      userOrderMapVo: {
        id: '',
        productCode: '',
        productName: '',
        hospName: '',
        state: '',
        fee: '',
        orderId: '',
        updateTime: '',
      }
    })
    const userHeartPlan = reactive({
      userOrderMapVo: {
        id: '',
        productCode: '',
        productName: '',
        hospName: '',
        state: '',
        fee: '',
        orderId: '',
        updateTime: '',
      }
    })
    const userGiftCards = reactive({
      userGiftCardsVo: {
        id: '',
        productCode: '',
        productName: '',
        hospName: '',
        stateStr: '',
        discount: '',
        updateTime: '',
      }
    })
    const changeTitle = (data) => {
      return "订单编号：" + data;
    };
    const checkState = (data) => {
      if (data == '已消耗') {
        return false;
      } else {
        return true;
      }
    };
    const checkStateStr = (data) => {
      if (data == '未领取') {
        return true;
      } else {
        return false;
      }
    };
    const getUserGift = (data) => {
      showConfirmDialog({
        title: '卡劵领取确认',
        message:
          '您是否确认领取此卡劵。',
      })
        .then(() => {
          console.log(data)
          request.get('/wxmanager/person/addUserGift', {
            params: {
              giftId: data
            }
          }).then((res) => {
            if(res.data.code == 20000){
              showToast('领取成功');
            }
            location.reload()
          })
        })
        .catch(() => {
          // on cancel
        });
    }
    const getHospGiftCards=()=>{
      getAddHospGiftCards().then((res) =>{
        if (res.data.code == 0) {
            showDialog({
                title: "请求成功",
                message: '卡劵请求已经成功提交，等待机构完成确认。',
                theme: "round-button",
            }).then(() => {
          
            });
          }else if(res.data.code == 50002){
            showDialog({
                title: "请求错误",
                message: '无需重复请求!上次卡劵未处理完。',
                theme: "round-button",
            }).then(() => {
        
            });
          }else{
            console.log("未知错误");
          }
      })
    }
    onMounted(() => {
      ulog.UserLog.path = router.currentRoute.value.fullPath;
      console.log("当前页面路径==" + ulog.UserLog.path);
      postUserLog(ulog.UserLog).then(() => {});
      getUserOrderList().then((res) => {
        userOrderList.userOrderMapVo = res.data.data;
        console.log(userOrderList.userOrderMapVo);
      })
      getUserOrderHealthPlan().then((res) => {
        userHeartPlan.userOrderMapVo = res.data.data;
        console.log(userHeartPlan.userOrderMapVo);
      })
      getdUserGiftCards().then((res) => {
        userGiftCards.userGiftCardsVo = res.data.data;
        console.log(userGiftCards.userGiftCardsVo);
      })
    })
    return {
      active,
      userOrderList,
      userHeartPlan,
      changeTitle,
      checkState,
      userGiftCards,
      checkStateStr,
      getUserGift,
      getHospGiftCards,
    };
  },
};
</script>
<style scoped>
/* 调整图像大小(最好用百分比) */
.van-card-img {
  width: 40% !important;
  height: 40% !important;
}

.text2DIndentation {
  font-size: 12px;
  text-align: left;
  margin-left: 2em;
}

.text3DIndentation {
  font-size: 12px;
  text-align: left;
  text-indent: 1em;
}
</style>
